define('views/blocks/CartCagnotteView',['jquery','underscore','backbone','app','SubView',
    'views/blocks/checkout/CagnotteCheckoutDialogView',
    'template!blocks/cart/cagnotte'
    ],
    function ($,_,Backbone,app,SubView,
              CagnotteCheckoutDialogView,
              templateCagnotte
              ) {

        //var checkoutModel;

        return Backbone.View.extend(SubView).extend({

            events: {
                'click .toggle-cagnotte-form':'onClick',
                'keyup .basic-input': 'keyInput',
                'blur .basic-input': 'keyInput',
                'submit .inline-button-form': 'applyCagnotte',
                'focusout .basic-input': 'focusOutField',

            },

            className: 'cart-cagnotte',

            initialize: function (options) {
                var view = this,
                    cart = app.getCart(),
                    customer = app.getCustomer();
                view.listenTo(cart, 'change:total_price_ttc change:cagnotte', view.updateValue);
                view.listenTo(cart, 'change:id_store', view.render);
                view.listenTo(customer,'change:customer_loyalty',view.updateValue);
                view.listenTo(customer,'change:id_customer', view.render);
                view.updateValue()
            },
            render:function(){
                var view = this,
                    customer = app.getCustomer(),
                    cart = app.getCart(),
                    used = cart.getCagnotte(),
                    formatUsed = cart.formatCagnotteUsed();

                view.$el.html(templateCagnotte({
                    btnLabelSubtitle:cart.formatCagnotteSubtitle(),
                    customer:customer,
                    formatUsed:formatUsed,
                    cagnotte:used,
                    exceptionStore:true
                }));
            },
            updateValue:function(){
                this.$('.cart-cagnotte--subtitle').text(app.getCart().formatCagnotteSubtitle());
            },

            onClick:function(e){
                var view = this,
                    message = app.t('merci de vous connecter pour pouvoir utiliser votre cagnotte','Checkout');
                app.getCart().requireAuthentification(function(success){
                    if(!success){
                        // noop
                    }else if(app.isMobile()){
                        new CagnotteCheckoutDialogView();
                    }else{
                        view.$el.addClass('active');
                        view.$('input').trigger('focus');
                    }
                },message);
            },

            focusOutField:function(e){
                var view = this, relatedTarget = e.relatedTarget || e.target.nextElementSibling;
                if(_.isNull(relatedTarget) || !view.$(relatedTarget).is('.btn-classic')){
                    view.$el.removeClass('active');
                }
            },

            keyInput:function(e){
                var currentTarget = e.currentTarget;
                if(e.keyCode === 27){
                    document.activeElement.blur();
                }
                this.updateFilledState(currentTarget.value.length!=0);
            },

            updateFilledState:function(filled){
                this.$('.inline-button-form').toggleClass('filled',filled);
            },

            applyCagnotte:function(e){
                e.preventDefault();
                var view = this,
                    btn = view.$('.btn-classic');
                var input = view.$('.basic-input'),
                    cart = app.getCart(),
                    inputVal = parseFloat(input.val().replace(',','.').replace(' ','')),
                    cagnotte = Math.min(cart.getPriceTTC() / cart.getCagnotteConversionRate(),inputVal),
                    cagnotteAmount = parseFloat(app.getCustomer().getCagnotteAmount()) || 0;

                function ButtonLoader(init){
                    btn.prop('disabled',init===true).toggleClass('loading',init===true);
                }

                if(cagnotteAmount<cagnotte){
                    app.alert({
                        title:app.t('Attention','UI'),
                        subtitle:app.t('Vous dépassez la limite de crédit dans votre cagnotte.','Checkout'),
                    },function(){
                        ButtonLoader(false);
                        input.val(cagnotteAmount.toFixed(2).replace(/\.00$/,''));
                        view.$el.addClass('active');
                        view.$('input').trigger('focus');
                    });
                    ButtonLoader(true);
                }else{
                    app.getCart().setCagnotte(cagnotte);
                    view.$el.removeClass('active');
                }


            }

        });
    });
